<template>
  <div :class="$style.panel">
    <div
      :class="$style.stepNumber"
      :style="{color: accent}">{{ stepNumber }}
    </div>
    <div :class="$style.instruction">
      <slot/>
    </div>

  </div>

</template>

<script>
/* Vue Components */
/* Meteor packages */
/* NPM packages */
/* Methods */
/* Everything else */

export default {
  name: 'Instruction',
  props: {
    stepNumber: {
      type: Number,
      required: true,
    },
    accent: {
      type: String,
      default: '#eea417',
    },
  },
  created() {
    window.addEventListener('resize', () => {
      this.$emit('location', this.$el.offsetLeft);
    });
  },
  mounted() {
    this.$emit('location', this.$el.offsetLeft);
    this.$el.style.color = '#ffff00';
  },
};
</script>
<style lang="scss"
       module>
@import "src/brand/brandColors.variables";

.panel {
  background: $gray-light;
  padding: 3.2rem 3.2rem 3.2rem 2rem;
  margin-bottom: 0.4rem;
  width: 100%;
  max-width: 37.6rem;
  //min-height: 13.8rem;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
}

.stepNumber {
  composes: standard from "src/brand/typography.scss";
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  background-color: $white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2.8rem;
  font-weight: 700;
  margin-right: 2rem;
}

.instruction {
  flex: 1;
  composes: standard from "src/brand/typography.scss";
  font-size: 1.6rem;
  line-height: 2.4rem;
  color: $steel-gray;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
}
</style>
